/** Ari brand gradient — shared by Button `ari` variant and AriIcon `gradient` variant. */
export const ARI_GRADIENT_STOPS = [
  { offset: "0%", color: "#B2A9FF" },
  { offset: "8.07%", color: "#B1A9FF" },
  { offset: "15.54%", color: "#B0A9FF" },
  { offset: "22.5%", color: "#ADA9FF" },
  { offset: "29.04%", color: "#AAA9FF" },
  { offset: "35.26%", color: "#A5A9FF" },
  { offset: "41.25%", color: "#A0A9FF" },
  { offset: "47.1%", color: "#9AA9FF" },
  { offset: "52.9%", color: "#93A9FF" },
  { offset: "58.75%", color: "#8BA9FF" },
  { offset: "64.74%", color: "#83A9FF" },
  { offset: "70.96%", color: "#7AA8FF" },
  { offset: "77.5%", color: "#70A8FF" },
  { offset: "84.46%", color: "#66A8FF" },
  { offset: "91.93%", color: "#5BA8FF" },
  { offset: "100%", color: "#50A8FF" },
] as const;

export const ARI_GRADIENT_CSS = `linear-gradient(180deg, ${ARI_GRADIENT_STOPS.map(
  (stop) => `${stop.color} ${stop.offset}`,
).join(", ")})`;
